export const navConstants = {
    NAV_REQUEST: 'NAV_REQUEST'
};
